<!-- Header -->
<div class="flex items-start sm:items-center justify-between gap-3 flex-wrap mb-6">
  <div>
    <h2 class="text-xl font-bold text-gray-900">Payments</h2>
    <p class="text-sm text-gray-500 mt-1">Monthly membership fee collection</p>
  </div>
  <div class="flex items-center gap-2">
    <button *ngIf="auth.isSuperAdmin()" (click)="showRecycleBin.set(true)" title="View deleted payments"
            class="flex items-center gap-2 bg-white border border-gray-300 text-gray-600 hover:text-blue-600 hover:border-blue-300 text-sm font-medium px-3 py-2 rounded-lg transition-colors">
      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 7h16M9 7V5a1 1 0 011-1h4a1 1 0 011 1v2m-7 4l1 7m4-7l-1 7M5 7l1 12a2 2 0 002 2h8a2 2 0 002-2l1-12"/>
      </svg>
      <span class="hidden sm:inline">Recycle bin</span>
    </button>
    <button (click)="openCreate()" *appHasPermission="301"
            class="flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium px-4 py-2 rounded-lg shadow-sm transition-colors">
      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/>
      </svg>
      Record Payment
    </button>
  </div>
</div>

<app-member-dues-alert class="block mb-4" />

<app-recycle-bin-modal
  *ngIf="auth.isSuperAdmin()"
  [open]="showRecycleBin()"
  entityKey="payments"
  title="Payments"
  (restored)="loadPayments()"
  (close)="showRecycleBin.set(false)"
></app-recycle-bin-modal>

@if (!hasBuSelected()) {
  <app-no-bu-selected entityLabel="payments" />
} @else {

<!-- Filters -->
<div class="bg-white rounded-xl border border-gray-100 shadow-sm p-4 mb-4">
  <div class="flex flex-wrap gap-3">
    <div class="relative flex-1 min-w-48">
      <svg class="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"/>
      </svg>
      <input type="text" [(ngModel)]="searchTerm" (ngModelChange)="onSearchChange()"
             placeholder="Search by receipt no, member name, NIC..."
             class="w-full pl-9 pr-4 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"/>
    </div>
    <select [(ngModel)]="filterMonth" (change)="onFilterChange()"
            class="px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none">
      <option [ngValue]="null">All Months</option>
      <option *ngFor="let m of months" [ngValue]="m.value">{{ m.name }}</option>
    </select>
    <select [(ngModel)]="filterYear" (change)="onFilterChange()"
            class="px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none">
      <option [ngValue]="null">All Years</option>
      <option *ngFor="let y of years" [ngValue]="y">{{ y }}</option>
    </select>
    <button *ngIf="searchTerm || filterMonth != null || filterYear != null"
            (click)="searchTerm = ''; filterMonth = null; filterYear = null; onFilterChange()"
            class="px-4 py-2 border border-gray-300 text-gray-600 text-sm rounded-lg hover:bg-gray-50 transition-colors">
      Clear
    </button>
  </div>
</div>

<!-- Error banner -->
<div *ngIf="errorMessage" class="flex items-center gap-2 bg-red-50 border border-red-200 rounded-lg p-4 mb-4">
  <svg class="w-5 h-5 text-red-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
  </svg>
  <p class="text-sm text-red-700 flex-1">{{ errorMessage }}</p>
  <button (click)="errorMessage = ''" class="text-red-400 hover:text-red-600">
    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
    </svg>
  </button>
</div>

<!-- Loading -->
<app-loader *ngIf="isLoading" caption="Loading payments…"></app-loader>

<!-- Table -->
<div *ngIf="!isLoading" class="bg-white rounded-xl border border-gray-100 shadow-sm overflow-hidden">
  <div class="px-5 py-4 border-b border-gray-100 flex items-center justify-between">
    <h3 class="text-sm font-semibold text-gray-700">Payment Records</h3>
    <span class="text-xs text-gray-500">{{ totalCount }} total</span>
  </div>

  <!-- Mobile card list -->
  <div class="md:hidden divide-y divide-gray-100">
    <div *ngFor="let payment of payments" class="p-4 space-y-2">
      <div class="flex items-start justify-between gap-3">
        <div class="min-w-0 flex-1">
          <div class="font-medium text-gray-900 truncate">{{ payment.memberName || ('#' + payment.memberId) }}</div>
          <div class="flex items-center gap-2 flex-wrap mt-0.5">
            <a [routerLink]="['/payments', payment.id]"
               class="font-mono text-xs text-blue-600 hover:text-blue-800 hover:underline">{{ payment.receiptNo || ('#' + payment.id) }}</a>
            <span *ngIf="payment.eventContributionId"
                  class="inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-[10px] font-semibold bg-purple-100 text-purple-700 ring-1 ring-purple-200">
              Event
            </span>
          </div>
          <div class="text-xs text-gray-500 mt-1">
            {{ monthName(payment.month) }} {{ payment.year }} · {{ payment.paymentMethod }} · {{ formatDate(payment.createdDate) }}
          </div>
          <div *ngIf="eventName(payment) as evName"
               class="mt-1 inline-flex items-center gap-1 text-xs text-purple-700 font-medium">
            <span class="truncate max-w-[220px]">{{ evName }}</span>
          </div>
        </div>
        <div class="text-right flex-shrink-0">
          <div class="font-semibold text-gray-900 whitespace-nowrap">Rs. {{ payment.amount | number:'1.2-2' }}</div>
        </div>
      </div>
      <div class="flex items-center justify-end gap-1">
        <button (click)="openReceipt(payment)" title="View Receipt"
                [disabled]="isLoadingReceipt"
                class="tap-target inline-flex items-center justify-center p-2 text-gray-400 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-colors disabled:opacity-50">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4"/>
          </svg>
        </button>
        <ng-container *ngIf="!payment.eventContributionId">
          <button (click)="openEdit(payment)" title="Edit" *appHasPermission="303"
                  class="tap-target inline-flex items-center justify-center p-2 text-gray-400 hover:text-amber-600 hover:bg-amber-50 rounded-lg transition-colors">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/>
            </svg>
          </button>
          <button (click)="confirmDelete(payment)" title="Delete" *appHasPermission="304"
                  class="tap-target inline-flex items-center justify-center p-2 text-gray-400 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
            </svg>
          </button>
        </ng-container>
      </div>
    </div>
    <div *ngIf="payments.length === 0" class="px-5 py-12 text-center text-gray-400 text-sm">
      No payments found
    </div>
  </div>

  <!-- Desktop table -->
  <div class="hidden md:block overflow-x-auto">
    <table class="w-full text-sm">
      <thead class="bg-gray-50 border-b border-gray-100">
        <tr>
          <th class="text-left px-5 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wider">Receipt</th>
          <th class="text-left px-5 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wider">Member</th>
          <th class="text-left px-5 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wider">Period</th>
          <th class="text-right px-5 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wider">Amount</th>
          <th class="text-left px-5 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wider">Method</th>
          <th class="text-left px-5 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wider">Date</th>
          <th class="text-right px-5 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wider">Actions</th>
        </tr>
      </thead>
      <tbody class="divide-y divide-gray-200">
        <tr *ngFor="let payment of payments" class="odd:bg-white even:bg-gray-100 hover:bg-blue-100 transition-colors">
          <td class="px-5 py-3">
            <div class="flex items-center gap-2">
              <a [routerLink]="['/payments', payment.id]"
                 class="font-mono text-xs text-blue-600 hover:text-blue-800 hover:underline">{{ payment.receiptNo || ('#' + payment.id) }}</a>
              <span *ngIf="payment.eventContributionId"
                    class="inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-[10px] font-semibold bg-purple-100 text-purple-700 ring-1 ring-purple-200"
                    title="Recorded from an event contribution">
                <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/>
                </svg>
                Event
              </span>
            </div>
          </td>
          <td class="px-5 py-3">
            <div class="font-medium text-gray-900">{{ payment.memberName || ('#' + payment.memberId) }}</div>
            <div *ngIf="payment.memberNic" class="text-xs text-gray-500 font-mono">{{ payment.memberNic }}</div>
            <div *ngIf="eventName(payment) as evName"
                 class="mt-1 inline-flex items-center gap-1 text-xs text-purple-700 font-medium"
                 [title]="'Event: ' + evName">
              <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/>
              </svg>
              <span class="truncate max-w-[220px]">{{ evName }}</span>
            </div>
          </td>
          <td class="px-5 py-3">
            <ng-container *ngIf="payment.eventContributionId; else monthlyPeriod">
              <div class="text-gray-900 text-xs font-semibold uppercase tracking-wider">Event</div>
              <div class="text-xs text-gray-500">{{ monthName(payment.month) }} {{ payment.year }}</div>
            </ng-container>
            <ng-template #monthlyPeriod>
              <span class="text-gray-600">{{ monthName(payment.month) }} {{ payment.year }}</span>
            </ng-template>
          </td>
          <td class="px-5 py-3 text-right font-semibold text-gray-900">Rs. {{ payment.amount | number:'1.2-2' }}</td>
          <td class="px-5 py-3">
            <span class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-gray-100 text-gray-700">
              {{ payment.paymentMethod }}
            </span>
          </td>
          <td class="px-5 py-3 text-gray-600">{{ formatDate(payment.createdDate) }}</td>
          <td class="px-5 py-3">
            <div class="flex items-center justify-end gap-1">
              <button (click)="openReceipt(payment)" title="View Receipt"
                      [disabled]="isLoadingReceipt"
                      class="p-1.5 text-gray-400 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-colors disabled:opacity-50">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4"/>
                </svg>
              </button>
              <ng-container *ngIf="!payment.eventContributionId">
                <button (click)="openEdit(payment)" title="Edit" *appHasPermission="303"
                        class="p-1.5 text-gray-400 hover:text-amber-600 hover:bg-amber-50 rounded-lg transition-colors">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/>
                  </svg>
                </button>
                <button (click)="confirmDelete(payment)" title="Delete" *appHasPermission="304"
                        class="p-1.5 text-gray-400 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
                  </svg>
                </button>
              </ng-container>
            </div>
          </td>
        </tr>
        <tr *ngIf="payments.length === 0">
          <td colspan="7" class="px-5 py-12 text-center text-gray-400 text-sm">
            No payments found
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Pagination -->
  <div *ngIf="totalPages > 1" class="px-5 py-4 border-t border-gray-100 flex items-center justify-between flex-wrap gap-3">
    <p class="text-sm text-gray-500">
      Showing {{ startIndex }} to {{ endIndex }} of {{ totalCount }} payments
    </p>
    <div class="flex items-center gap-1">
      <button (click)="changePage(currentPage - 1)" [disabled]="currentPage === 1"
              class="px-3 py-1.5 text-sm border border-gray-300 rounded-lg disabled:opacity-40 hover:bg-gray-50 transition-colors">
        Previous
      </button>
      <button *ngFor="let p of pages" (click)="changePage(p)"
              [class]="currentPage === p
                ? 'px-3 py-1.5 text-sm bg-blue-600 text-white rounded-lg'
                : 'px-3 py-1.5 text-sm border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors'">
        {{ p }}
      </button>
      <button (click)="changePage(currentPage + 1)" [disabled]="currentPage === totalPages"
              class="px-3 py-1.5 text-sm border border-gray-300 rounded-lg disabled:opacity-40 hover:bg-gray-50 transition-colors">
        Next
      </button>
    </div>
  </div>
</div>

}

<!-- Form modal -->
<app-payment-form
  [open]="showFormModal"
  [payment]="editingPayment"
  (closed)="closeForm()"
  (saved)="onPaymentSaved($event)">
</app-payment-form>

<!-- Receipt modal -->
<app-receipt-view
  [open]="showReceipt"
  [receipt]="currentReceipt"
  (closed)="closeReceipt()">
</app-receipt-view>

<!-- Delete confirmation -->
<app-confirm-dialog
  [open]="pendingDeletePayment !== null"
  title="Delete this payment?"
  message="The payment will be removed and the receipt voided. The action is logged in the audit trail."
  [entityName]="pendingDeleteLabel()"
  confirmLabel="Delete payment"
  loadingLabel="Deleting..."
  [loading]="isDeleting"
  (confirm)="performDelete()"
  (cancel)="cancelDelete()">
</app-confirm-dialog>
